export default __webpack_public_path__ + "static/media/89.79d31aba.png";